import { render, staticRenderFns } from "./crm-expires.vue?vue&type=template&id=6ca2341d&"
import script from "./crm-expires.vue?vue&type=script&lang=js&"
export * from "./crm-expires.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports